import * as service from './service'
export default {
  namespace: 'recruitEquipmentPayInfoNew',
  state: {
    paymentInfoData: {},
    toPayData: {}
  },
  effects: {
    * paymentInfo ({ payload }, { call, put }) {
      const res = yield call(service.paymentInfo, payload)
      yield put({
        type: 'save',
        payload: {
          paymentInfoData: res.data.data
        }
      })
      return res.data
    },
    * toPay ({ payload }, { call, put }) {
      const res = yield call(service.toPay, payload)
      yield put({
        type: 'save',
        payload: {
          toPayData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
